<template>
  <div>
    <div class="modal-payment">
      <div class="modal-content-sc">
        <img src="/images/congrats-icon.svg" />
        <h6>Payment successfull!</h6>
        <p>Thanks for your purchase</p>
        <router-link :to="{ name: 'Home' }" class="subscription-btn"
          >Go Home</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Success",
  data: () => {
    return {
      host: null,
      msisdn: null,
      errorMessage: "",
      successMessage: ""
    };
  },
  async created() {
    this.host = this.$root.url();

    let transactionId = this.$route.query.transactionId;

    const path = "authLogin";
    const url = `${this.host}/${path}?transactionId=${transactionId}`;
    axios
      .get(url)
      .then(response => {
        if (response.data.success === true) {
          localStorage.clear();
          localStorage.setItem("phone", response.data.phone);
          if (response.data.login === true) {
            this.$router.push({ name: "Home" });
          } else {
            this.$router.push({ name: "Profile" });
          }
        } else {
          this.$router.push({ name: "Home" });
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {}
};
</script>

<style scoped>
.modal-payment {
  position: fixed;
  z-index: 99;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.7);
}

.modal-content-sc {
  max-width: 640px;
}

.modal-content-sc h6 {
  font-size: 24px;
  font-weight: 600;
  margin-top: 20px;
}

.modal-content-sc p {
  font-size: 14px;
  font-weight: 600;
  margin-top: 10px;
}

.modal-content-sc .subscription-btn {
  border-width: 0;
  padding: 12px;
  border-radius: 3px;
  resize: none;
  border: none;
  color: #ffffff;
  display: block;
  font-size: 1rem;
  line-height: 1.5;
  background-image: -webkit-linear-gradient(-55deg, #377dff 30%, #a859b1 100%);
  font-family: inherit;
  font-weight: 500;
  margin-top: 30px;
  text-decoration: none;
}
</style>
